import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import { Button } from "antd";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Case, Default, Switch } from "react-if";
import styles from "./index.module.less";

/**
 * 快速搜索范围切换入口
 */
export default function QuickSearch({
  pageScope,
  changeScope,
}: {
  pageScope: {
    data: IUser | IBoardInfo | IDomainInfo | ITopicInfo;
    type: string;
  };
  changeScope: (scope: string) => void;
}) {
  const user = useAppStore((s) => s.user);
  const router = useRouter();

  const isInBoard = router.pathname.includes("/boards/[boardId]");
  const isInDomain = router.pathname.includes("/domains/[domainId]");
  const isInTopic = router.pathname.includes("/topics/[urlname]");

  /** 当前页面适用的搜索范围内容 */
  const scopeTxt = useMemo(() => {
    const scopeData = pageScope?.data;
    let targetStr = "";
    if (scopeData) {
      if (isInBoard) {
        targetStr = (scopeData as IBoardInfo).title || "";
      } else if (isInDomain) {
        targetStr = (scopeData as IDomainInfo).domain_name || "";
      } else if (isInTopic) {
        targetStr = (scopeData as ITopicInfo).title || "";
      } else {
        if ("urlname" in scopeData) {
          targetStr =
            user?.urlname === scopeData.urlname
              ? "我的"
              : (scopeData as IUser).username || "";
        }
      }
    }

    targetStr =
      targetStr.length <= 10 ? targetStr : targetStr.slice(0, 10) + "...";
    return targetStr;
  }, [isInBoard, isInDomain, isInTopic, pageScope, user]);

  return (
    <div className={styles.quickSearch} data-content-source="分类栏">
      <Switch>
        <Case condition={isInBoard}>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchBoardPin");
            }}
            data-gd-click="button_click"
            data-button-name="搜索画板内采集"
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="dashboard" />
            <span className={styles.text}>{scopeTxt}</span>
            <span className={styles.name}>采集</span>
          </Button>
        </Case>
        <Case condition={isInDomain}>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchDomainPin");
            }}
            data-gd-click="button_click"
            data-button-name="搜索域名采集"
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="link" />
            <span className={styles.text}>{scopeTxt}</span>
            <span className={styles.name}>采集</span>
          </Button>
        </Case>
        <Case condition={scopeTxt}>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchUserBoard");
            }}
            data-gd-click="button_click"
            data-button-name={
              scopeTxt === "我的" ? "搜索我的画板" : "搜索用户的画板"
            }
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="ic_account" />
            <span className={styles.text}>{scopeTxt}</span>
            <span className={styles.name}>画板</span>
          </Button>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchUserPin");
            }}
            data-gd-click="button_click"
            data-button-name={
              scopeTxt === "我的" ? "搜索我的采集" : "搜索用户的采集"
            }
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="ic_account" />
            <span className={styles.text}>{scopeTxt}</span>
            <span className={styles.name}>采集</span>
          </Button>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchMaterial");
            }}
            data-gd-click="button_click"
            data-button-name="搜索商用素材"
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="ic_copyright" />
            <span className={styles.text}>商用素材</span>
          </Button>
        </Case>
        <Default>
          <Button
            className={styles.button}
            onClick={() => {
              changeScope("searchMaterial");
            }}
            data-gd-click="button_click"
            data-button-name="搜索商用素材"
          >
            <span className={styles.type}>搜索</span>
            <HBIcon className={styles.icon} type="ic_copyright" />
            <span className={styles.text}>商用素材</span>
          </Button>
        </Default>
      </Switch>
    </div>
  );
}
